'use strict';
export var portalDirectivesModule = angular.module('portal.directives', ['dev-stack-frontend.directives']);